export default pos => {
    switch (pos) {
        case 'top':
            return 'bottom'
        case 'bottom':
            return 'top'
        case 'left':
            return 'right'
        case 'right':
            return 'left'
        default:
            return null
    }
}
